(function () {
    'use strict';
    angular.module('app').config(routePlanningUrlConfig);

    routePlanningUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function routePlanningUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/route-planning', {
            templateUrl: '/templates/pages/route-planning/route-planning.html',
            controller: 'RoutePlanningController',
            controllerAs: 'vm',
            params: {
                parent: 'jobs',
                subParent: 'jobs',
                htmlTitle: 'JOB ASSIGNMENT',
                pageTitle: 'JOB ASSIGNMENT',
                icon: 'fa fa-home' // todo: need to fix this one here...
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
})();


// WEBPACK FOOTER //
// ./js/urls/route-planning.js